import { render } from "./CreateDemoContent.vue?vue&type=template&id=a5a841e4"
import script from "./CreateDemoContent.vue?vue&type=script&lang=js"
export * from "./CreateDemoContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__